function Project({ item }) {
  return (
    <div key={item.id} className="flex flex-col items-center text-center">
      <div className="mb-8">
        <img className="h-60 w-96" src={item.image} alt="" />
      </div>
      <div style={{height:"50px"}}>
        <p className="text-xl">{item.name}</p>
        <p>Tech Stack : {item.techStack}</p>
      </div>

      <div style={{ display: "flex", gap: "10px" }}>
        <a href={item.path} target="_blank">
          <button className="mt-8 btn-md btn bg-violet-700 hover:bg-violet-500 ">
            Live Demo
          </button>
        </a>
        <a href={item.gitCode} target="_blank">
          <button className="btn mt-8 btn-md bg-fuchsia-700 hover:bg-fuchsia-600 ">
            Source Code
          </button>
        </a>
      </div>
      <p className="m-5">{item.proDesc}</p>
    </div>
  );
}

export default Project;
